var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-progress-bar"},[_c('el-progress',{attrs:{"percentage":_vm.percentage,"color":_vm._customProgressColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }